import { transport } from 'config/transport';

export function callApiGetDuThuCongDoan(congDoanId, academicYear) {
    return transport.get(`/congdoan/${congDoanId}/duthu`, { params: { academicYear } });
}
